import { FaArrowRightLong } from "react-icons/fa6";
import TopSpace from '../components/TopSpace';
import Banner from '../components/banners/Banner';
import VideoBanner from '../components/banners/VideoBanner';
import Blog from '../components/blog/Blog'
import CaseStudy from '../components/casestudy/CaseStudy'
import GetinTouch from '../components/getintouch/GetInTouch'
import OurClient from "../components/ourclients/OurClient";
import Service from "../components/services/Service";
import Stats from "../components/stats/Stats";
import Testimonial from "../components/testimonials/Testimonial";
import {serviceObject} from "../providers/GlobalObjects"
import useDocumentTitle from "../hooks/useDocumentTitle";

const Home = () => {

    useDocumentTitle('Home Page')
    
    const reviewData = {
        heading:"What our clients says",
        description:"",
        show_view_more:true,
        view_more:{
            icon:<FaArrowRightLong className='ms-2' size={20}/>,
            icon_postion:"right",
            button_label:"View All",
            button_link:"/reviews",
            target:"_self"
        },
        reviews:[
            {
                id:1,
                reviewer:"Joe Doe",
                star:"5-Star",       
                company_name:"Managing Director @ dummytesting Ltd.",
                star_number:5,
                datetime:"",
                review:"Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nam impedit repellat hic. Fugiat nam adipisci est veritatis quo impedit, sed inventore et cumque, neque quos, quis atque recusandae soluta vel. Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nam impedit repellat hic. Fugiat nam adipisci est veritatis quo impedit, sed inventore et cumque, neque quos, quis atque recusandae soluta vel. Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nam impedit repellat hic. Fugiat nam adipisci est veritatis quo impedit, sed inventore et cumque, neque quos, quis atque recusandae soluta vel."
            },
            {
                id:2,
                reviewer:"Jone Adu",
                star:"5-Star",       
                company_name:"Managing Director @ dummytesting Ltd.",
                star_number:5,
                datetime:"",
                review:"It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like)."
            },
            {
                id:3,
                reviewer:"H. Rackham.",
                star:"5-Star",       
                company_name:"Managing Director @ dummytesting Ltd.",
                star_number:5,
                datetime:"",
                review:"The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from 'de Finibus Bonorum et Malorum' by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham."
            },
            {
                id:4,
                reviewer:"J. Knight",
                star:"5-Star",       
                company_name:"Managing Director @ dummytesting Ltd.",
                star_number:5,
                datetime:"",
                review:"Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo."
            },
            {
                id:5,
                reviewer:"Sara Jone",
                star:"5-Star",       
                company_name:"Managing Director @ dummytesting Ltd.",
                star_number:5,
                datetime:"",
                review:"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga."
            },   
            {
                id:6,
                reviewer:"Matt Pot",
                star:"5-Star",       
                company_name:"Managing Director @ dummytesting Ltd.",
                star_number:5,
                datetime:"",
                review:"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga."
            },            
        ]
    };

    return (
        <TopSpace>
            <Banner />  
            <Stats /> 
            <Service
                services={serviceObject}
            />
            <CaseStudy />
            <Testimonial 
                testimonial={reviewData}
            />
            <Blog />
            <OurClient />  
            <GetinTouch />                      
        </TopSpace>
    );
};

export default Home;